import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';

import { getWaitingListCustomersForShop } from '../waitingListCustomers/selectors';
import WaitingListContainer from './WaitingList';
import { getShop } from '../../../auth/selectors';
import ShopWaitingList from '../components/ShopWaitingList';
import { shopFetchWaitingListCustomers } from '../waitingListCustomers/actions';

const fetch = compose(
  connect(
    (state, ownProps) => ({
      shopId: getShop(state),
      customers: getWaitingListCustomersForShop(state, ownProps.currentDate),
    }),
    {
      shopFetchWaitingListCustomers,
    }
  ),
  withHandlers({
    fetch: props => date =>
      props.shopFetchWaitingListCustomers(props.shopId, date),
  })
);
const ShopWaitingListContainer = WaitingListContainer(fetch)(ShopWaitingList);

export default ShopWaitingListContainer;
